/* Shorts dikey feed denetleyici (framework yok).
   - IntersectionObserver → tek aktif short: iframe göm (autoplay/muted/loop), pasifte boşalt.
   - Dip-sentinel → /shorts/feed JSON'undan sonraki sayfayı append (sonsuz kaydırma).
   - Yorum alt-sheet: fetch + AJAX post (like/dislike zaten app.js delegated handler'ıyla çalışır).
   - Aktif short'a view-beacon (slug başına bir kez).
   - Dokun → ses aç/kapa (muted autoplay tarayıcı gereği).
   - prefers-reduced-motion → autoplay yok (poster kalır). */
(function () {
  'use strict';
  var feed = document.querySelector('.shorts-feed');
  if (!feed) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var soundOn = false;              // ilk kullanıcı hareketinde açılır (tarayıcı sesli-autoplay engeli)
  var active = null;                // o an aktif .short
  var viewed = {};                  // slug → beacon atıldı
  var loading = false, done = false;
  var HLS_OK = window.Hls && window.Hls.isSupported();

  /* ---------- Native oynatıcı (hls.js / Safari native HLS) ---------- */
  function reveal(short) { short.classList.add('is-playing'); }   // poster fade → video görünür
  function mountPlayer(short, warm) {
    var v = short.querySelector('.short__video');
    var url = short.getAttribute('data-hls');
    if (!v || !url || reduceMotion || v._mounted) return;
    v._mounted = true;
    v.muted = !soundOn;
    v.addEventListener('loadeddata', function () { if (short === active) reveal(short); });   // ilk kare hazır
    v.addEventListener('playing', function () { if (short === active) reveal(short); });
    if (v.canPlayType('application/vnd.apple.mpegurl')) {          // Safari/iOS native HLS
      v.src = url; if (!warm) v.play().catch(function () {});
    } else if (HLS_OK) {                                            // hls.js (Chrome/Firefox/Android)
      var hls = new Hls({ maxBufferLength: 18, maxMaxBufferLength: 40, startLevel: -1, capLevelToPlayerSize: true });
      v._hls = hls; hls.loadSource(url); hls.attachMedia(v);
      hls.on(Hls.Events.MANIFEST_PARSED, function () { if (short === active) v.play().catch(function () {}); });
    }
  }
  function unmountPlayer(short) {
    var v = short.querySelector('.short__video');
    short.classList.remove('is-playing', 'is-paused', 'show-center');
    if (!v || !v._mounted) return;
    try { if (v._hls) { v._hls.destroy(); v._hls = null; } } catch (_) {}
    try { v.pause(); v.removeAttribute('src'); v.load(); } catch (_) {}
    v._mounted = false;
  }
  function activate(short) {                                       // warm short aktif oldu → oynat (kare hazırsa anında göster)
    var v = short.querySelector('.short__video'); if (!v) return;
    v.muted = !soundOn;
    if (v.readyState >= 2) reveal(short);
    v.play().catch(function () {});
  }
  var activeSince = 0;
  function emitDwell(short) {
    if (!short || !activeSince || !window.teEvent) return;
    var slug = short.getAttribute('data-slug');
    var dwell = Date.now() - activeSince;
    if (slug) window.teEvent({ slug: slug, is_shortie: true, type: dwell < 3000 ? 'skip' : 'dwell', value: dwell });
  }
  var warmEl = null;
  function nextShort(short) {
    var n = short.nextElementSibling;
    while (n && !n.classList.contains('short')) n = n.nextElementSibling;
    return n;
  }
  // Sonraki 1 short'u önden yükle (autoplay'siz; en fazla aktif + 1 video).
  function prewarmNext(short) {
    var nx = nextShort(short);
    if (warmEl && warmEl !== nx && warmEl !== active) unmountPlayer(warmEl);
    warmEl = nx;
    if (nx && nx !== active) { var nv = nx.querySelector('.short__video'); if (nv && !nv._mounted) mountPlayer(nx, true); }
  }
  function setActive(short) {
    if (active === short) return;
    if (active) { emitDwell(active); unmountPlayer(active); }   // önceki short: dwell/skip + boşalt
    active = short;
    if (!active) return;
    activeSince = Date.now();
    var v = active.querySelector('.short__video');
    if (v && v._mounted) activate(active);                      // önden yüklendi → oynat
    else mountPlayer(active, false);                            // taze mount + oynat
    beacon(active);
    var slug = active.getAttribute('data-slug');
    if (slug && window.teEvent) window.teEvent({ slug: slug, is_shortie: true, type: 'play' });
    prewarmNext(active);
    rafStart();
  }
  window.addEventListener('pagehide', function () { emitDwell(active); });

  /* ---------- Akışkan seek ilerleme (rAF 60fps — timeupdate'in kesikliği yerine) ---------- */
  var raf = 0;
  function rafTick() {
    raf = 0;
    if (active && !active._seeking) {
      var v = active.querySelector('.short__video'), fill = active.querySelector('.short__seek-fill');
      if (v && fill && v.duration) fill.style.width = (v.currentTime / v.duration * 100) + '%';
    }
    rafStart();
  }
  function rafStart() { if (!raf) raf = requestAnimationFrame(rafTick); }

  /* ---------- View beacon (slug başına bir kez) ---------- */
  function beacon(short) {
    var slug = short.getAttribute('data-slug');
    var url = short.getAttribute('data-view');
    if (!slug || !url || viewed[slug]) return;
    var key = 'te_view_' + slug;
    try { if (sessionStorage.getItem(key)) { viewed[slug] = 1; return; } } catch (_) {}
    // Kısa bekleme: hemen kaydırıp geçeni sayma. Hâlâ aktifse gönder.
    setTimeout(function () {
      if (active !== short || viewed[slug]) return;
      viewed[slug] = 1;
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin', keepalive: true })
        .then(function () { try { sessionStorage.setItem(key, '1'); } catch (_) {} })
        .catch(function () { viewed[slug] = 0; });
    }, 2500);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting && en.intersectionRatio >= 0.6) setActive(en.target);
    });
  }, { threshold: [0, 0.6, 0.9], root: feed });
  function observeShorts(scope) {
    var list = (scope || feed).querySelectorAll('.short');
    Array.prototype.forEach.call(list, function (s) { io.observe(s); });
  }
  observeShorts();
  // İlk short'u hemen aktif yap (ilk giriş)
  var first = feed.querySelector('.short');
  if (first) setActive(first);

  /* ---------- İlk kullanıcı hareketi → sesi aç (tarayıcı sesli-autoplay engelini aşar) ---------- */
  var firstGesture = true;
  function enableSound() {
    if (soundOn) return; soundOn = true;
    if (active) { var v = active.querySelector('.short__video'); if (v) v.muted = false; }
  }
  feed.addEventListener('pointerdown', function () { if (firstGesture) { firstGesture = false; enableSound(); } }, { capture: true });

  /* ---------- Dokun (media) = pause/play + orta ikon (rail/link/seek hariç) ---------- */
  feed.addEventListener('click', function (e) {
    if (e.target.closest('.short__rail') || e.target.closest('a') || e.target.closest('[data-seek]')) return;
    var short = e.target.closest('.short'); if (!short || short !== active) return;
    var v = short.querySelector('.short__video'); if (!v || !v._mounted) return;
    if (v.paused) { v.play().catch(function () {}); short.classList.remove('is-paused'); }
    else { v.pause(); short.classList.add('is-paused'); }
  });

  /* ---------- Seek çubuğu: sürükle → canlı scrub (görüntü de değişir) ---------- */
  feed.addEventListener('pointerdown', function (e) {
    var seek = e.target.closest('[data-seek]'); if (!seek) return;
    var short = seek.closest('.short'); if (short !== active) return;
    var v = short.querySelector('.short__video'); if (!v || !v.duration) return;
    var track = seek.querySelector('.short__seek-track'), fill = seek.querySelector('.short__seek-fill');
    short._seeking = true; short._wasPlaying = !v.paused; v.pause(); seek.classList.add('is-drag');
    try { seek.setPointerCapture(e.pointerId); } catch (_) {}
    var sraf = 0, tgt = -1;
    function pct(x) { var r = track.getBoundingClientRect(); return Math.min(1, Math.max(0, (x - r.left) / r.width)); }
    function applySeek() { sraf = 0; if (tgt >= 0) { try { v.currentTime = tgt * v.duration; } catch (_) {} } }
    function move(ev) { var p = pct(ev.clientX); fill.style.width = (p * 100) + '%'; tgt = p; if (!sraf) sraf = requestAnimationFrame(applySeek); }
    function up(ev) {
      var p = pct(ev.clientX); try { v.currentTime = p * v.duration; } catch (_) {}
      short._seeking = false; seek.classList.remove('is-drag');
      if (short._wasPlaying) v.play().catch(function () {});
      seek.removeEventListener('pointermove', move); seek.removeEventListener('pointerup', up); seek.removeEventListener('pointercancel', up);
    }
    seek.addEventListener('pointermove', move); seek.addEventListener('pointerup', up); seek.addEventListener('pointercancel', up);
    move(e); e.preventDefault();
  });

  /* ---------- Sonsuz kaydırma ---------- */
  function loadMore() {
    if (loading || done) return;
    var sentinel = feed.querySelector('.shorts-feed__sentinel');
    if (!sentinel) { done = true; return; }
    loading = true;
    var page = parseInt(feed.getAttribute('data-page') || '1', 10) + 1;
    var base = feed.getAttribute('data-feed');
    var qs = 'src=' + encodeURIComponent(feed.getAttribute('data-src') || 'all')
           + '&model=' + encodeURIComponent(feed.getAttribute('data-model') || '')
           + '&page=' + page;
    fetch(base + '?' + qs, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        var items = (d && d.items) || [];
        if (!items.length) { done = true; loading = false; return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = items.join('');
        var added = [];
        while (tmp.firstElementChild) { var el = tmp.firstElementChild; feed.insertBefore(el, sentinel); added.push(el); }
        feed.setAttribute('data-page', String(page));
        added.forEach(function (s) { if (s.classList && s.classList.contains('short')) io.observe(s); });
        if (!d.more) done = true;
        loading = false;
      })
      .catch(function () { loading = false; });
  }
  var sio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) loadMore(); });
  }, { root: feed, rootMargin: '600px' });
  var sent = feed.querySelector('.shorts-feed__sentinel');
  if (sent) sio.observe(sent);

  /* ---------- Yorum alt-sheet ---------- */
  var sheet = document.getElementById('comment-sheet');
  var sheetList = document.getElementById('comment-sheet-list');
  var sheetForm = document.getElementById('comment-sheet-form');
  var sheetTitle = document.getElementById('comment-sheet-title');
  var sheetSlug = null;

  function baseFor(slug, short) {
    // data-view (".../video/{slug}/view") → ".../video/{slug}"  (BASE_PATH'e dayanıklı)
    var v = short && short.getAttribute('data-view');
    if (v) return v.replace(/\/view$/, '');
    return null;
  }
  function openSheet(slug, short) {
    if (!sheet) return;
    sheetSlug = slug;
    sheet.dataset.base = baseFor(slug, short) || '';
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (sheetList) sheetList.innerHTML = '<div class="csheet__empty">Yükleniyor…</div>';
    var url = (sheet.dataset.base || '') + '/comments';
    fetch(url, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (sheetList) sheetList.innerHTML = (d && d.html) || '<div class="csheet__empty">Yorum yok.</div>';
        if (sheetTitle) sheetTitle.textContent = 'Yorumlar' + (d && d.count ? ' · ' + d.count : '');
        if (sheetForm && d && d.enabled === false) sheetForm.hidden = true;
      })
      .catch(function () { if (sheetList) sheetList.innerHTML = '<div class="csheet__empty">Yorumlar yüklenemedi.</div>'; });
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var oc = e.target.closest('[data-action="open-comments"]');
    if (oc) { var sh = oc.closest('.short'); openSheet(oc.getAttribute('data-slug'), sh); return; }
    if (e.target.closest('[data-action="close-comments"]')) { closeSheet(); return; }
    var sc = e.target.closest('[data-action="share-short"]');
    if (sc) {
      var shareUrl = sc.getAttribute('data-url');
      if (navigator.share) { navigator.share({ url: shareUrl }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(shareUrl).then(function () { sc.classList.add('short__act--copied'); setTimeout(function () { sc.classList.remove('short__act--copied'); }, 1200); }).catch(function () {}); }
      return;
    }
  });

  // Yorum gönder (AJAX; JS yoksa zaten form yok/redirect). Sheet açıkken slug'a POST.
  if (sheetForm) {
    sheetForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var base = (sheet && sheet.dataset.base) || '';
      if (!base) return;
      var input = sheetForm.querySelector('input[name="body"]');
      var btn = sheetForm.querySelector('button');
      if (btn) btn.disabled = true;
      fetch(base + '/comment', {
        method: 'POST', headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin',
        body: new FormData(sheetForm)
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (btn) btn.disabled = false;
        if (d && d.ok) {
          if (input) input.value = '';
          // Listeyi tazele (yeni yorum + sayaç)
          fetch(base + '/comments', { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (dd) {
              if (sheetList) sheetList.innerHTML = (dd && dd.html) || sheetList.innerHTML;
              if (sheetTitle) sheetTitle.textContent = 'Yorumlar' + (dd && dd.count ? ' · ' + dd.count : '');
            }).catch(function () {});
        }
      }).catch(function () { if (btn) btn.disabled = false; });
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
})();
